export default "__VITE_ASSET__Ao0yX628__"